import React, { useState } from "react";
import styles from "./TabBar.module.css";
import clsx from "clsx";
import { KnowledgeType } from "../../util/KnowledgeType";
import ExportContentModal from "../../pages/newManager/components/sideMain/brainList/modal/ExportContentModal";
import { useAppDispatch, useAppSelector } from "../../store/common/hooks";
import { setKnowledgeType } from "../../store/brain.slice";

interface TabBarProps {}

const TabBar: React.FC<TabBarProps> = ({}) => {
  const knowledgeType = useAppSelector((s) => s.brain.knowledgeType);
  const dispatch = useAppDispatch();

  const handleTabClick = (type: KnowledgeType) => {
    dispatch(setKnowledgeType(type));
  };

  const [openExportModal, setOpenExportModal] = useState(false);

  const handleExportModal = () => {
    setOpenExportModal((prev) => !prev);
  };

  return (
    <>
      <div className={styles["tab-bar"]}>
        <div className={styles["tab-button-group"]}>
          <button
            className={clsx(
              styles["tab-button"],
              knowledgeType === KnowledgeType.DOCUMENT && styles["active"]
            )}
            onClick={() => {
              handleTabClick(KnowledgeType.DOCUMENT);
            }}
          >
            Documents
          </button>
          <button
            className={clsx(
              styles["tab-button"],
              knowledgeType === KnowledgeType.FAQ && styles["active"]
            )}
            onClick={() => {
              handleTabClick(KnowledgeType.FAQ);
            }}
          >
            FAQs
          </button>
          <button
            className={clsx(
              styles["tab-button"],
              knowledgeType === KnowledgeType.INTENT && styles["active"]
            )}
            onClick={() => {
              handleTabClick(KnowledgeType.INTENT);
            }}
          >
            Intent
          </button>
          <button
            className={clsx(
              styles["tab-button"],
              knowledgeType === KnowledgeType.SOP && styles["active"]
            )}
            onClick={() => {
              handleTabClick(KnowledgeType.SOP);
            }}
          >
            SOP
          </button>
        </div>

        <button
          className={clsx(styles["export-button"])}
          onClick={handleExportModal}
        >
          Export
        </button>
      </div>

      <ExportContentModal
        isOpen={openExportModal}
        onClose={() => {
          setOpenExportModal(false);
        }}
      />
    </>
  );
};

export default TabBar;
